export interface Reservation {
  reservationId: string;
  userId: string;
  reservationStatus: ReservationStatus;
  userShippingPreference: string;
  deliverySchedule: string;
  purchaseOrderNumber: string | null;
  billingAddressInformation: {
    addressId: string;
    addressVersion: string | null;
    organizationId: string;
  };
  remainingPendingOrders: number | null;
  createdDate: string;
  lastModifiedDate: string;
  priceReferenceIdentifier: string;
  displayName: string;
  internalUserId: string;
  version: number;
  reservationPricingInfo: {
    totalPrice: string;
    totalDoses: number;
    totalListPrice: string;
    subtotals: {
      [key: string]: {
        totalPrice: string;
        totalDoses: number;
        totalListPrice: string;
      };
    };
  };
  reservationNumber: string;
  cartId: string | null;
  initialConfirmedDate: string;
  soldToOrganizationId: string;
}

export interface User {
  userId: string;
  email: string;
  userStatus: string;
  personId: string;
  authenticatedId: string;
  firstName: string;
  lastName: string;
  createdDate: string;
  createdBy: string;
  updatedBy: string;
  updatedDate: string;
  selectedContract?: {
    id: string;
    displayName: string;
    priceReferenceType: string;
    medicalIdentifier: string;
    lastUpdatedDateTimeUTC: string;
  };
  defaultAddress?: unknown;
  paymentCustomerId?: string;
  userType?: string;
  customerSelfSelectedTaxExemptionDateTimeUTC?: string;
  isCustomerTaxExemptionSelfSelectionPastTenDays?: boolean;
  contacts?: Array<{ type: string; id: string }>;
  selectedOrgId?: string | null;
  currentSoldToOrgId?: string;
}

export interface ReservationList {
  reservationsWithUsers: Array<{
    reservation: Reservation;
    placedByUser: User;
  }>;
  pagination: {
    nextPageKey: string | null;
    pageSize: number;
  };
  totalPages: number;
}

export enum ReservationStatus {
  Cancelled = "CANCELLED",
  Created = "CREATED",
  Ordered = "ORDERED",
  Pending = "PENDING"
}

export enum ReservationSortableColumnKeys {
  DatePlaced = "lastModifiedDate",
  Status = "reservationStatus"
}
